export default function TitleCaser(str) {
  return str.toLowerCase().split(' ').map(word => (word.charAt(0).toUpperCase() + word.slice(1))).join(' ');
}



// WEBPACK FOOTER //
// ./src/shared/helpers/title-caser.js